import { render, staticRenderFns } from "./wasteproductionMain.vue?vue&type=template&id=761aaa04&scoped=true"
import script from "./wasteproductionMain.vue?vue&type=script&lang=js"
export * from "./wasteproductionMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761aaa04",
  null
  
)

export default component.exports